import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import logo from "../assets/logo.png"; // Make sure logo path is correct
import '../styles/fonts.css';


const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showInvestorForm, setShowInvestorForm] = useState(false);
  const [investorSubmitted, setInvestorSubmitted] = useState(false);
  const [investor, setInvestor] = useState({ firstName: "", lastName: "", email: "", company: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      onLogin(userCredential.user);
    } catch (err) {
      console.error(err);
      setError("Invalid login credentials.");
    }
  };

  const handleInvestorSubmit = async (e) => {
    e.preventDefault();
    const body = `First Name: ${investor.firstName}\nLast Name: ${investor.lastName}\nEmail: ${investor.email}\nCompany: ${investor.company}`;
    try {
      await fetch(`${process.env.REACT_APP_API_BASE}/send-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: investor.firstName + " " + investor.lastName,
          company: investor.company,
          email: investor.email,
          message: body,
          category: "Investor Register of Interest"
        })
      });
      setInvestorSubmitted(true);
    } catch (error) {
      console.error("Error sending investor form:", error);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.leftPanel}>
        <div>
          <h1 style={styles.investorHeading}>Investors</h1>
          <h2 style={styles.investorSubheading}>Register your interest below</h2>

          {!showInvestorForm && !investorSubmitted && (
            <button onClick={() => setShowInvestorForm(true)} style={styles.inviteButton}>
              Enquire
            </button>
          )}

          {showInvestorForm && !investorSubmitted && (
            <form onSubmit={handleInvestorSubmit} style={styles.form}>
              <input type="text" placeholder="First Name" required value={investor.firstName} onChange={(e) => setInvestor({ ...investor, firstName: e.target.value })} style={styles.input} />
              <input type="text" placeholder="Last Name" required value={investor.lastName} onChange={(e) => setInvestor({ ...investor, lastName: e.target.value })} style={styles.input} />
              <input type="email" placeholder="Email" required value={investor.email} onChange={(e) => setInvestor({ ...investor, email: e.target.value })} style={styles.input} />
              <input type="text" placeholder="Company" required value={investor.company} onChange={(e) => setInvestor({ ...investor, company: e.target.value })} style={styles.input} />
              <button type="submit" style={styles.registerButton}>Register</button>
            </form>
          )}

          {investorSubmitted && <p style={{ color: '#fff', fontSize: '1.1rem' }}>Thank you for your interest, we will be in touch shortly.</p>}
        </div>
      </div>

      <div style={styles.rightPanel}>
        <h2 style={styles.heading}>Login to Data Vault</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          <input type="email" placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} style={styles.input} />
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} style={styles.input} />
          <button type="submit" style={styles.loginButton}>Login</button>
          {error && <p style={styles.error}>{error}</p>}
        </form>
        <a href="mailto:barryl@nezo-app.com" style={styles.contactLink}>Contact Us</a>
        <img src={logo} alt="V-Quest Logo" style={styles.bottomLogo} />
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    display: "flex",
    height: "100vh",
    fontfamily: "'Gotham Rounded', sans-serif",
    fontstyle: "normal",
    fontsynthesis: "none",
    background: "#f9fbfa"
  },
  leftPanel: {
    flex: 1,
    background: "linear-gradient(to bottom, #80bbaa, #217867)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderTopLeftRadius: "20px",
    borderBottomLeftRadius: "20px",
    padding: "2rem",
    color: "#fff",
    textAlign: "center"
  },
  rightPanel: {
    flex: 1,
    background: "#ffffff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "3rem",
    borderTopRightRadius: "20px",
    borderBottomRightRadius: "20px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    position: "relative"
  },
  logo: {
    display: "none"
  },
  bottomLogo: {
    position: "absolute",
    bottom: "20px",
    right: "20px",
    width: "100px",
    opacity: 0.9
  },
  heading: {
    fontSize: "1.6rem",
    marginBottom: "1.2rem",
    color: "#243c4c"
  },
  investorHeading: {
    fontSize: "2.4rem",
    fontWeight: "bold",
    marginBottom: "0.5rem"
  },
  investorSubheading: {
    fontSize: "1.2rem",
    marginBottom: "1.5rem"
  },
  form: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "320px",
    gap: "1rem"
  },
  input: {
    padding: "0.8rem",
    borderRadius: "30px",
    border: "1px solid #d4dde3",
    outline: "none",
    paddingLeft: "1rem",
    backgroundColor: "#f1f7f5"
  },
  loginButton: {
    backgroundColor: "#217867",
    border: "none",
    color: "white",
    padding: "0.8rem",
    borderRadius: "30px",
    cursor: "pointer",
    fontWeight: "600",
    letterSpacing: "0.05em"
  },
  registerButton: {
    backgroundColor: "#80bbaa",
    border: "none",
    color: "white",
    padding: "0.8rem",
    borderRadius: "30px",
    cursor: "pointer",
    fontWeight: "600",
    marginTop: "30px",
    letterSpacing: "0.05em"
  },
  inviteButton: {
    backgroundColor: "#ffffff",
    color: "#217867",
    padding: "0.8rem 2rem",
    borderRadius: "30px",
    border: "none",
    fontSize: "1rem",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    letterSpacing: "0.05em"
  },
  contactLink: {
    marginTop: "1rem",
    fontSize: "0.9rem",
    color: "#217867",
    textDecoration: "none"
  },
  error: {
    color: "red",
    fontSize: "0.85rem",
    marginTop: "0.5rem",
    textAlign: "center"
  }
};

export default Login;
